import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { ApiService } from 'src/app/services';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';
import { UpsertRemoteWorkExceptionRequestBody } from 'src/app/models/remote_work_exception_request.model';

@Component({
  selector: 'app-manage-remote-work-dialog',
  templateUrl: './manage-remote-work-dialog.component.html',
  styleUrl: './manage-remote-work-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatCheckbox,
    MatFormField,
    MatLabel,
    MatInput,
    MatDialogActions,
    MatButton,
    MatIcon,
    DatePipe,
  ],
})
export class ManageRemoteWorkDialogComponent {
  private dialog = inject<MatDialogRef<ManageRemoteWorkDialogComponent>>(MatDialogRef);
  protected fb = inject(FormBuilder);
  private api = inject(ApiService);
  data = inject(MAT_DIALOG_DATA);

  form: FormGroup;

  protected readonly saving = signal(false);

  constructor() {
    this.form = this.fb.group({
      has_remote_work_monday: [this.data.remote_work_days.monday, Validators.required],
      has_remote_work_tuesday: [this.data.remote_work_days.tuesday, Validators.required],
      has_remote_work_wednesday: [this.data.remote_work_days.wednesday, Validators.required],
      has_remote_work_thursday: [this.data.remote_work_days.thursday, Validators.required],
      has_remote_work_friday: [this.data.remote_work_days.friday, Validators.required],
      has_remote_work_saturday: [this.data.remote_work_days.saturday, Validators.required],
      has_remote_work_sunday: [this.data.remote_work_days.sunday, Validators.required],
      reason: ['', Validators.required],
    });
  }

  createRemoteWorkExceptionRequest(): void {
    if (this.form.invalid || this.saving()) return;

    this.saving.set(true);
    this.dialog.disableClose = true;

    const data = this.form.value as UpsertRemoteWorkExceptionRequestBody;

    this.api.createEmployeeRemoteWorkExceptionRequest(this.data.user_id, this.data.from, this.data.to, data).subscribe({
      next: (): void => {
        this.dialog.close();
      },
      error: (): void => {
        this.saving.set(false);
        this.dialog.disableClose = false;
      },
    });
  }
}
